// extracted by mini-css-extract-plugin
module.exports = {"root":"fix-perfil-detalles_root__3MbLR","SectionTitle":"fix-perfil-detalles_SectionTitle__2zmp0"};